// Словарь с переводами серверных ошибок на русский язык
export const errorTranslations: Record<string, string> = {
    'This attribute must be unique': 'Это значение уже используется',
    'Invalid email format': 'Неверный формат электронной почты',
    'This field is required': 'Это поле обязательно для заполнения',
    'Password must be at least 6 characters': 'Пароль должен содержать минимум 6 символов',
    'Invalid INN format': 'Неверный формат ИНН',
    'Invalid phone number': 'Неверный формат номера телефона',
  };
  
  /**
   * Функция для перевода сообщений об ошибках с английского на русский
   * @param message исходное сообщение на английском
   * @returns переведенное сообщение или исходное, если перевод не найден
   */
  export const translateError = (message: string): string => {
    return errorTranslations[message] || message;
  };